"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventApp = /** @class */ (function () {
    function EventApp(conf) {
        this.config = conf;
        this.receiver = conf.receiver;
        this.dispatcher = conf.dispatcher;
        this.logger = conf.logger;
        this.configure();
        this.logger.info('EventApp: READY');
    }
    EventApp.prototype.configure = function () {
        this.logger.info('app:configure');
        this.receiver.setEventCallback(this.acceptEvent.bind(this));
    };
    EventApp.prototype.acceptEvent = function (event) {
        this.logger.info('app:acceptEvent', event);
        this.dispatcher.dispatch(event);
    };
    return EventApp;
}());
exports.default = EventApp;
